import React from "react";

export default function CafeCard({
  title,
  description,
  children,
  footer,
  logoSrc,
  logoAlt = "Cafe logo",
  className = "",
}) {
  return (
    <div
      className={`w-full max-w-sm rounded-[32px] bg-[#FFFDEE] px-8 py-10 shadow-[0_24px_48px_-12px_rgba(15,76,129,0.25)] space-y-8 text-center ${className}`}
    >
      {logoSrc ? (
        <div className="flex justify-center">
          <img
            src={logoSrc}
            alt={logoAlt}
            className="h-20 w-20 object-contain"
          />
        </div>
      ) : null}

      <div className="space-y-2">
        <h1 className="text-2xl font-semibold text-slate-900">{title}</h1>
        {description ? (
          <p className="text-base text-slate-600">{description}</p>
        ) : null}
      </div>

      <div className="space-y-4">{children}</div>

      {footer ? <div className="pt-6 border-t border-slate-200">{footer}</div> : null}
    </div>
  );
}
